import Model, { attr } from '@ember-data/model'
import { Type } from '@warp-drive/core-types/symbols'
import type NumberTransform from 'teacher-ui-client/transforms/number'

export default class CollectionStat extends Model {
  @attr<NumberTransform>('number') declare sharedCollectionCount: number

  @attr<NumberTransform>('number') declare booksInSharedCollectionsCount: number;

  [Type] = 'book-library/collection-stat' as const
}
